import {ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import '../../../shared/components/navigable';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {FormControl, FormGroup} from '@angular/forms';
import {Store} from '@ngrx/store';
import * as fromProducts from '../../reducers';
import * as SearchActions from '../../actions/mobile-search.actions';
import {Attribute, AttributeOption} from '../../models/attribute';
import {SearchFilterConverter} from '../../services/search-filter-converter';
import {SearchFilter} from 'src/app/shared/components/advanced-searchbox/advanced-searchbox.component';
import {LoadCollectionCommand} from '../../models/product-commands';
import {SortDirection, SortField, SortOrder} from '../../../shared/models/magento-search-filter';
import {MultipleFieldSelectMobile, SearchableAttribute} from "../../models/advanced-search";


/*TODO: This whole component has to be refactored at some point because it is not very good implemented.
*  There are a lot of duplications with product-sorted-search-component which can be extracted
* Because of time pressure, it ise left as it is.
*/


@Component({
    selector: 'app-advanced-search',
    templateUrl: './mobile-advanced-search.component.html',
    styleUrls: ['./mobile-advanced-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedSearchComponent implements OnInit {
    private static DEFAULT_SORT_OPTION = [SortField.SKU.toUpperCase(), SortDirection.ASC]


    @Output()
    closeSiteMenu = new EventEmitter();

    @Output()
    search = new EventEmitter<LoadCollectionCommand>();


    @Input()
    decorTypeOpen: boolean;

    @Input()
    occasionTypeOpen: boolean;

    @Input()
    productTypeOpen: boolean;

    @Input()
    purposeTypeOpen: boolean;

    @Input()
    productCategoryTypeOpen: boolean;

    @Input()
    colorTypeOpen: boolean;

    @Input()
    sortTypeOpen: boolean;

    @Input()
    searchFilters: SearchFilter[];

    @Input()
    attributes: Attribute[];

    searchableAttributes: SearchableAttribute = {
        decor: {attributeCode: 'decor', i18id: 'product-sorted-search_field-decor'},
        occasion: {attributeCode: 'occasion', i18id: 'product-sorted-search_field-occasion'},
        productType: {attributeCode: 'product_type_hb', i18id: 'product-sorted-search_field-product-type'},
        purpose: {attributeCode: 'purpose', i18id: 'product-sorted-search_field-purpose'},
        productCategory: {attributeCode: 'product_category_hb', i18id: 'product-sorted-search_field-category'},
        color: {attributeCode: 'color', i18id: 'product-sorted-search_field-color'}
    }

    form = new FormGroup({
        decor: new FormControl({value: []}),
        productType: new FormControl({value: []}),
        occasion: new FormControl({value: []}),
        purpose: new FormControl({value: []}),
        category: new FormControl({value: []}),
        color: new FormControl({value: []}),
        sort: new FormControl(AdvancedSearchComponent.DEFAULT_SORT_OPTION),
        advanced: new FormControl()
    });

    // For some reason the translation with the translation service doesn't work, so the i18n marker is used here
    // This is different from the desktop search and at some point has to be unified ...
    sortOptions = [
        {i18n: 'article', label: 'By Article', value: ['SKU', 'ASC']},
        {i18n: 'hi-price', label: 'Highest Price', value: ['PRICE', 'DESC']},
        {i18n: 'lo-price', label: 'Lowest Price', value: ['PRICE', 'ASC']},
        {i18n: 'new-in', label: 'New In', value: ['NEW', 'ASC']}
    ];

    multipleFieldSelections: MultipleFieldSelectMobile[];

    constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer,
                private store: Store<fromProducts.State>) {


        this.matIconRegistry.addSvgIcon(
            'hering-search',
            this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/header/search.svg')
        );
    }

    ngOnInit(): void {
        this.multipleFieldSelections = [
            {
                formName: 'decor',
                i18nId: this.searchableAttributes.decor.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.decor.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.decor.attributeCode, false),
                isOpen: this.decorTypeOpen
            },
            {
                formName: 'productType',
                i18nId: this.searchableAttributes.productType.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.productType.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.productType.attributeCode),
                isOpen: this.productTypeOpen
            },
            {
                formName: 'occasion',
                i18nId: this.searchableAttributes.occasion.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.occasion.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.occasion.attributeCode),
                isOpen: this.occasionTypeOpen
            },
            {
                formName: 'purpose',
                i18nId: this.searchableAttributes.purpose.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.purpose.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.purpose.attributeCode),
                isOpen: false
            },
            {
                formName: 'category',
                i18nId: this.searchableAttributes.productCategory.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.productCategory.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.productCategory.attributeCode),
                isOpen: false
            },
            {
                formName: 'color',
                i18nId: this.searchableAttributes.color.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.color.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.color.attributeCode),
                isOpen: false
            }
        ]

        this.processSearchFilter(this.searchFilters);
        this.disableEmptyControls();
    }


    get decors(): AttributeOption[] {
        return this.getAttributeOptionsOf(this.searchableAttributes.decor.attributeCode, false);
    }

    get occasions(): AttributeOption[] {
        return this.getAttributeOptionsOf(this.searchableAttributes.occasion.attributeCode);
    }

    get productTypes(): AttributeOption[] {
        return this.getAttributeOptionsOf(this.searchableAttributes.productType.attributeCode);
    }

    get purpose(): AttributeOption[] {
        return this.getAttributeOptionsOf(this.searchableAttributes.purpose.attributeCode);
    }

    get productCategory(): AttributeOption[] {
        return this.getAttributeOptionsOf(this.searchableAttributes.productCategory.attributeCode);
    }

    get color(): AttributeOption[] {
        return this.getAttributeOptionsOf(this.searchableAttributes.color.attributeCode);
    }

    private getAttributeOptionsOf(code: string, sort = true): AttributeOption[] {
        const attribute = this.attributes.filter(a => a.code === code);
        if (attribute.length === 0) {
            return [];
        }

        const attributeOptions = attribute[0].options
            .filter(option => option.label.trim().length > 0 && option.value.trim().length > 0);

        if (sort) {
            return attributeOptions.sort((o1, o2) => {
                return o1.label.toLowerCase() < o2.label.toLowerCase() ? -1 : 1;
            });
        }

        return attributeOptions;
    }

    private processSearchFilter(searchFilters: SearchFilter[]) {
        if (searchFilters == null) {
            return;
        }

        this.multipleFieldSelections.forEach(selection => {
            this.form.controls[selection.formName].setValue(searchFilters
                .filter(f => f.model == selection.attributeCode)
                .map(f => f.value)
            )
        })

        // advanced:
        const advancedControl = this.form.controls['advanced'];
        const advancedFilter = searchFilters.filter(f => f.model === SearchFilterConverter.ADVANCED_FILTER_ATTRIBUTE_CODE);
        if (advancedFilter.length > 0) {
            advancedControl.setValue(advancedFilter[0].value.value);
        }
    }

    onCloseSiteMenu() {
        this.closeSiteMenu.emit();
    }

    back() {
        this.store.dispatch(SearchActions.closeSubmenu());
    }

    openSubmenu(menuType: string) {
        this.store.dispatch(SearchActions.openSubmenu({menuType}));
    }

    submitSearch(): void {
        let form = this.form.controls['sort'].value;
        const sortOrders = [{field: SortField[form[0]], direction: SortDirection[form[1]]}];
        const searchFilters = this.createSearchFilters();
        this.onSearch(searchFilters, sortOrders);
    }

    private createSearchFilters(): SearchFilter[] {
        let searchFilters = this.multipleFieldSelections.reduce<SearchFilter[]>((acc, curr) => {
            const searchFilter = this.form.controls[curr.formName].value.map(value => {
                    return {model: curr.attributeCode, value: value}
                }
            )

            if (searchFilter.length > 0) {
                acc.push(...searchFilter)
            }

            return acc
        }, [])

        const advancedControl = this.form.controls['advanced'];
        if (advancedControl.value != null && (advancedControl.value as string).trim().length > 0) {
            const advancedValue = (advancedControl.value as string).trim();
            searchFilters.push({
                model: SearchFilterConverter.ADVANCED_FILTER_ATTRIBUTE_CODE,
                value: {
                    value: advancedValue,
                    label: advancedValue
                }
            });
        }
        return searchFilters;
    }

    private onSearch(searchFilters: SearchFilter[], sortOrders: SortOrder[]) {
        console.log('search was submitted', searchFilters);
        this.search.emit({searchFilters: searchFilters, sortOrders: sortOrders});
        this.back();
        this.onCloseSiteMenu();
    }

    resetDropdowns(): void {
        if (this.decorTypeOpen) {
            this.form.controls['decor'].reset([]);
            return;
        }

        if (this.occasionTypeOpen) {
            this.form.controls['occasion'].reset([]);
            return;
        }

        if (this.productTypeOpen) {
            this.form.controls['productType'].reset([]);
            return;
        }

        if (this.sortTypeOpen) {
            this.form.controls['sort'].reset(AdvancedSearchComponent.DEFAULT_SORT_OPTION);
            return;
        }

        Object.entries(this.form.controls).forEach(formEntry => {
                const controlName = formEntry[0];
                const formControl = formEntry[1];

                if (controlName === 'advanced') {
                    formControl.reset();
                    return;
                }

                if (controlName === 'sort') {
                    formControl.reset(AdvancedSearchComponent.DEFAULT_SORT_OPTION);
                    return;
                }

                formControl.reset([]);
            }
        )
    }

    isInSelection(): boolean {
        return this.occasionTypeOpen || this.decorTypeOpen || this.productTypeOpen ||
            this.sortTypeOpen || this.purposeTypeOpen || this.productCategoryTypeOpen || this.colorTypeOpen;
    }

    @HostListener('window:resize', ['$event'])
    onWindowResize() {
        if (window.innerWidth > 959) {
            this.onCloseSiteMenu();
        }
    }

    private disableEmptyControls() {
        // reset disable / enable form control state.
        this.multipleFieldSelections.forEach(selection => {
            if (selection.attributeOptions.length === 0) {
                this.form.controls[selection.formName].disable();
            }
        })
    }
}
